import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ClinicDepartment } from '../../domain/models/clinic-department.model';
import { IDepartmentsRepository } from '../../domain/repositories/departments.repository';
import { DepartmentsRemoteDatasource } from '../datasources/remote/departments.remote-datasource';
import { DepartmentMapper } from '../mappers/department.mapper';

@Injectable()
export class DepartmentsRepositoryImpl implements IDepartmentsRepository {
  private readonly datasource = inject(DepartmentsRemoteDatasource);
  private readonly mapper = inject(DepartmentMapper);

  public getDepartments(organizationId: number): Observable<ClinicDepartment[]> {
    return this.datasource.getDepartments(organizationId).pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toClinicDepartment(dto))),
    );
  }
}
